package utils

import i18n.LocaleManager
import i18n.StringKey
import i18n.tr

/**
 * Localized month names, in the two forms the UI needs.
 *
 * The `MONTH_*` strings are capitalized because they were written as standalone chart
 * labels ("Juillet"). French capitalizes month names only at the start of a sentence,
 * so dropping that value into "disponible à épargner en %s" produces "en Juillet",
 * which is wrong. [inSentence] is the form to use inside a sentence; [of] is the
 * standalone label.
 *
 * Months are 1-based, matching [DashboardMonth].
 */
object MonthNames {

    private val KEYS = listOf(
        StringKey.MONTH_JANUARY, StringKey.MONTH_FEBRUARY, StringKey.MONTH_MARCH,
        StringKey.MONTH_APRIL, StringKey.MONTH_MAY, StringKey.MONTH_JUNE,
        StringKey.MONTH_JULY, StringKey.MONTH_AUGUST, StringKey.MONTH_SEPTEMBER,
        StringKey.MONTH_OCTOBER, StringKey.MONTH_NOVEMBER, StringKey.MONTH_DECEMBER,
    )

    /** Standalone label — "July", "Juillet". Empty when [month] is out of 1..12. */
    fun of(month: Int): String = KEYS.getOrNull(month - 1)?.tr() ?: ""

    /**
     * The form that belongs inside a sentence — "July", "juillet". English is
     * unchanged; French is lowercased, which is the rule for every French month name
     * that isn't sentence-initial.
     */
    fun inSentence(month: Int): String {
        val name = of(month)
        return if (LocaleManager.getCurrentLocale().code == "fr") name.lowercase() else name
    }
}
